// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/yves_default." + ({"193":"script-loader","677":"paypal-buttons"}[chunkId] || chunkId) + ".js";
};